import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['menu', 'icon','avatar', 'menuItem']

  connect() {
    this._handleOutsideClick = this._handleOutsideClick.bind(this);
  }

  disconnect() {
    document.removeEventListener('click', this._handleOutsideClick);
  }

  toggle() {
    if (this._viewportIsMobile()) {
      this.menuTarget.classList.toggle('hidden');
      this.iconTarget.classList.toggle('rotate-90');
      this.iconTarget.classList.toggle('-rotate-90');
    } else {
      this._toggleSubmenu();
      this._displayMenuText();
    }

    if (!this.menuTarget.classList.contains('hidden')) {
      document.addEventListener('click', this._handleOutsideClick);
    } else {
      document.removeEventListener('click', this._handleOutsideClick);
    }
  }

  toggleUserMenuOnCollapse() {
    this._toggleUserMenu();
    this._hideSubmenu();
    this._displayMenuText();
  }

  _handleOutsideClick(event) {
    if (this.element.contains(event.target)) return;

    this._hideSubmenu();

    document.removeEventListener('click', this._handleOutsideClick);
  }

  _toggleUserMenu() {
    this._toggleAvatar();
    this._toggleIcon();
  }

  _toggleAvatar() {
    this.avatarTargets.forEach(avatar => {
      avatar.classList.toggle('sm:hidden');
    })
  }

  _toggleIcon() {
    this.iconTarget.classList.toggle('sm:hidden');
  }

  _toggleSubmenu() {
    ['hidden', 'flex', 'absolute', 'pt-3', 'ml-5', 'pr-2',
      'py-1', 'rounded-r-md', 'bottom-5'].forEach(klass => {
      this.menuTarget.classList.toggle(klass);
    })

    this.menuTarget.style = `left: ${this._sideBarWidth()}px;`;
  }

  _hideSubmenu() {
    ['absolute', 'pr-2',
      'py-1', 'rounded-r-md', 'bottom-5'].forEach(klass => {
      this.menuTarget.classList.remove(klass);
    });

    ['hidden', 'flex', 'pt-3', 'ml-5'].forEach(klass => {
      this.menuTarget.classList.add(klass);
    });
  }

  _displayMenuText() {
    this.menuItemTargets.forEach(item => {
      item.classList.remove('sm:hidden');
    });
  }

  _sideBarWidth() {
    return document.querySelector('.js-sidebar-menu').offsetWidth;
  }

  _viewportIsMobile() {
    return window.innerWidth < 640;
  }
}
